module.exports = __webpack_public_path__ + "img/android-download.bd4c87e3.png";